import axios from '../helpers/axiosConfig';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

function CreatCategorie() {
  const initialValues = {
    name: '',
  };
  useEffect(() => {
    if (!localStorage.getItem('accessToken')) {
      navigate('/login');
    }
  }, []);

  const navigate = useNavigate();

  const Enregister = (data) => {
    axios
      .post('/categorie', data, {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((response) => {
        //console.log(response);
        navigate('/listcategorie');
      });
  };

  const validation = Yup.object().shape({
    name: Yup.string().min(3).max(50).required('Veuillez remplir le Titre'),
  });

  return (
    <React.Fragment>
      <div>Creat Categorie</div>
      <Formik initialValues={initialValues} onSubmit={Enregister} validationSchema={validation}>
        <Form>
          <div className="d-flex">
            <div className="col">
              <label htmlFor="name">Categorie : </label>
              <ErrorMessage className="text-danger" name="name" component="span" />
              <Field className="form-control" id="name" name="name" placeholder="Nom catégorie" autoComplete="off" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button className="mt-3 btn btn-primary" type="submit">
                Enregistrer
              </button>
            </div>
          </div>
        </Form>
      </Formik>
    </React.Fragment>
  );
}

export default CreatCategorie;
